import { useState, useEffect } from "react";
import "./ResponseContentEnd.css";
import { Question } from "effno-core";
import { useSelector } from "react-redux";
import { selectUIStates } from "../../redux/features/appData";
import { FormSocials } from "../form-socials/FormSocials";
import config from "environment";
import { redirect } from "react-router-dom";
import { ResponseNavigate } from "./ResponseNavigate";
import { EndBranding } from "../form-widgets/EndBranding";

const debugMode = config.debugMode;

// if question is blank this means we have a 
// default end built in

type ResponseContentEndProps = {
    question?: Question;
    responseValues: string;
    isPreview: boolean;
    isMobileLayout: boolean;
    isLastQuestion: boolean;
    commentMode: boolean;
    onPrev?: () => void;
    redirectURL?: string;
}

export const ResponseContentEnd = ({
    question,
    responseValues,
    isPreview,
    isMobileLayout,
    isLastQuestion,
    commentMode,
    onPrev,
    redirectURL
} : ResponseContentEndProps) => {

    // const uiStates = useSelector(selectUIStates);

    const [settings, setSettings] = useState<any | undefined>(undefined);

    useEffect(() => {
        if (question) {
            const questionSettings = JSON.parse(question.settings);
            setSettings(questionSettings);
        }
    }, [question])

    console.log("ResponseContentEnd: ", question, settings);
    console.log("BrandingOn: ", settings?.brandingOn);
    
    return (
        <div className="form-content-body">

            {/* {debugMode && question &&
                <div className="response-content-question-id">
                    {question.id}
                </div>
            } */}

            {redirectURL &&
                <div className="response-content-redirect">
                    Would redirect to: {redirectURL}
                </div>
            }
            
            {!redirectURL &&
                <div className="response-content-end">
                    {question &&
                        <>
                            <div 
                                className="response-content-end-title"
                                data-testid={`response-content-title:${question ? 
                                    question.title : "**Default_End**"}`}
                            >
                                {question.title}
                            </div>

                            <div 
                                className="response-content-end-description"
                                data-testid={`response-content-description:${question ? 
                                    question.description : "**Default_End**"}`}
                                >
                                {question.description}
                            </div>
                        </>
                    }

                    {!question &&   
                        <div className="response-content-end-forced">
                            Thank you for your response!
                        </div>
                    }
                    
                    <div className="response-content-end-socials">
                        {settings?.socialShareOn && 
                            <FormSocials />
                        }
                    </div>
                   

                    {(settings?.brandingOn || !question) &&
                        <EndBranding />
                        // <div className="response-content-end-branding">
                        //     <div 
                        //         className="response-navigate-branding"
                        //         onClick={() => window.open("https://effno.co", "_blank")}
                        //     >
                        //         Powered by&nbsp;<b>effno</b>
                        //     </div>
                        // </div>
                    }
                </div>
            }

            {isPreview &&
                // <ResponseNavigate key="reg-navigate" onNext={undefined} onPrev={onPrev} />
                <ResponseNavigate 
                    key="reg-navigate"
                    center={true}
                    isMobileLayout={isMobileLayout}
                    isLastQuestion={isLastQuestion}
                    commentMode={commentMode}
                    onSubmit={undefined}
                    onNext={undefined}
                    onPrev={onPrev}
                />
            }

        </div>
    )
}